import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
    selector: 'tea-shop-fe-refunds-policy',
    templateUrl: './refunds-policy.component.html',
    styleUrl: './refunds-policy.component.css'
})
export class RefundsPolicyComponent {
  private metaDataService = inject(MetaDataService);


  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Refunds Policy',
      image: '/assets/contact/sencha-logo.png',
    });
  }
}
